import React from "react";
import { FaEdit } from "react-icons/fa";

const EditOrderAlert = ({ isVisible, onCancel, onConfirm, clientName }) => {
  if (!isVisible) return null;

  return (
    <div
      onClick={onCancel}
      style={{
        position: "fixed", inset: 0, zIndex: 50,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        background: "rgba(17,24,39,0.45)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e5e7eb",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          padding: "28px 24px",
          width: "100%",
          maxWidth: 360,
        }}
      >
        {/* Icon */}
        <div style={{
          width: 48, height: 48, borderRadius: "50%",
          background: "#eef2ff",
          border: "1px solid #c7d2fe",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 16px",
        }}>
          <FaEdit style={{ color: "#4338ca", fontSize: 20 }} />
        </div>

        {/* Title */}
        <h3 style={{ fontSize: 16, fontWeight: 500, color: "#111827", margin: "0 0 8px", textAlign: "center" }}>
          Modifica ordine
        </h3>

        {/* Message */}
        <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6, margin: "0 0 20px", textAlign: "center" }}>
          Sei sicuro di voler modificare l'ordine per{" "}
          <strong style={{ color: "#111827" }}>{clientName}</strong>?
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "1px solid #e5e7eb", background: "#f9fafb",
              color: "#374151", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg, #4f46e5, #6366f1)",
              color: "#fff", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Conferma
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditOrderAlert;